export default "__VITE_ASSET__D2gi0zmA__"